module.exports = __webpack_public_path__ + "static/media/Hamburger_icon.86595150.svg";